import { Flex, Image, Link, Text } from '@chakra-ui/react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { LocalGameInfo } from '../../service/games';
import { RoomsStats } from '../../service/lobby';
import { GameStatCounts } from './GameStatCounts';

interface GameDetailProps {
    game: LocalGameInfo;
    stats?: RoomsStats;
}

export const GameListItem: React.FC<GameDetailProps> = ({ game, stats }) => {
    return (
        <Flex direction={'column'} className={'game-info'}>
            <Link as={ReactRouterLink} to={`/game/${game.id}`}>
                <Image src={game.header} className={'gamelist-image'} />
            </Link>
            <Text>{game.name}</Text>
            <GameStatCounts
                gamesCount={stats?.totalSessions || 0}
                playersCount={stats?.totalPlayers || 0}
            />
        </Flex>
    );
};
